import {
	ChangeDetectionStrategy,
	Component,
	CUSTOM_ELEMENTS_SCHEMA,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import type { LlmDefinition } from '@go-modules/interfaces/llm-definition';
import type { BaseMarker } from '@go-modules/interfaces/markers/marker';
import { PanelModule } from '@go-modules/components/panel/panel.module';
import { NgxToolbarModule } from '@go-modules/components/toolbar/toolbar.module';
import { NgxToolbarButtonModule } from '@go-modules/components/toolbar/toolbar-button/toolbar-button.module';
import { MarkerDisplayModule } from '@go-modules/components/marker-display/marker-display.module';
import { Action } from '@go-modules/components/toolbar/toolbar-button/action-to-icon-class-map';

@Component({
	selector: 'ai-marker-set-panel',
	standalone: true,
	imports: [
		TranslateModule,
		PanelModule,
		NgxToolbarModule,
		NgxToolbarButtonModule,
		MarkerDisplayModule
	],
	templateUrl: './ai-marker-set-panel.component.html',
	styleUrls: ['./ai-marker-set-panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AiMarkerSetPanelComponent implements OnChanges {
	@Input() public llmDefinitions: LlmDefinition[] | null = null;
	@Input() public canPreview: boolean = false;
	@Input() public title?: string | null;
	@Input() public aiPrompts?: unknown;
	@Output() public onEdit = new EventEmitter<void>();
	@Output() public onRemove = new EventEmitter<void>();
	@Output() public onPreview = new EventEmitter<void>();

	public markers: BaseMarker[] = [];
	public readonly toolbarActions = Action;

	public ngOnChanges (changes: SimpleChanges): void {
		if (changes.llmDefinitions) {
			this.markers = this.buildMarkers(this.llmDefinitions);
		}
	}

	private buildMarkers (definitions: LlmDefinition[] | null | undefined): BaseMarker[] {
		return definitions?.map((definition) => definition?.tags?.[0] ?? null)
			.filter((marker): marker is BaseMarker => marker !== null) ?? [];
	}
}
